import React, { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../context/AuthContext'; 
import { ESTADOS_PEDIDO } from '../shared/utils/estadosPedido';
import DeliveryCard from './DeliveryCard';
import Pusher from 'pusher-js';
import Swal from 'sweetalert2';

const API_BASE = 'http://localhost:5000/api';
const PHP_API = "http://localhost/clavelina-backend-php/src/Routes/delivery";
// Añade la ruta de producción para la carga inicial
const API_BASE_PROD = "https://clavelinacarnes.com/clavelina-backend-php/src/Routes/delivery";

export default function DeliveryPanel() {
  const { user } = useContext(AuthContext); 
  const [envios, setEnvios] = useState([]);
  const [confirmaciones, setConfirmaciones] = useState([]);
  const [filtroActivo, setFiltroActivo] = useState('pendientes');

  const deliveryUuid = user?.id;
  const nombreDelivery = user?.nombre;

  const parseEnvio = (data) => {
    if (typeof data === 'object' && data !== null) return data;
    try {
      return JSON.parse(data);
    } catch (e) {
      return { direccion: data || 'Sin dirección', nombre: 'Cliente', telefono: 'N/A' };
    }
  };

 // ================================================================================
  // --- NUEVO ENRUTADOR UNIVERSAL PARA ACCIONES DE DELIVERY (MIGRADO A PHP INTERNO)
  // ================================================================================
  async function enviarAccionDelivery(endpointPhp, pedidoId) {
    if (!user?.token) { alert("Error de sesión"); return false; }

    try {
      // 🌐 RUTA DIRECTA BLINDADA: Apuntamos directo a la carpeta física de rutas en producción
      const URL_ACCION_PROD = `https://clavelinacarnes.com/clavelina-backend-php/src/Routes/delivery/${endpointPhp}`;

      const res = await fetch(URL_ACCION_PROD, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${user.token}` 
        },
        body: JSON.stringify({ pedido_id: String(pedidoId) })
      });

      const contentType = res.headers.get("content-type");
      let data = null;
      if (contentType && contentType.includes("application/json")) {
        data = await res.json();
      }

      if (res.ok && (data?.success || !data)) {
        return true;
      } else {
        alert(data?.error || "El servidor PHP rechazó la acción.");
        return false;
      }
    } catch (e) {
      console.error(`❌ Error en fetch hacia ${endpointPhp}:`, e);
      return false;
    }
  }

  // --- COMUNICACIÓN CON ADMIN (BRIDGE) ---
  // --- COMUNICACIÓN CON ADMIN (BRIDGE) ---
  async function handleBridgeAction(pedido_id, nuevoEstadoBridge) {
    if (!user?.token) return;
    const idNormalizado = String(pedido_id);

    try {
      // 🌐 RUTA DIRECTA BLINDADA: Saltamos PHP_API y apuntamos al archivo real en cPanel
      const URL_BRIDGE_PROD = "https://clavelinacarnes.com/clavelina-backend-php/src/Routes/delivery/actualizar_bridge.php";

      const res = await fetch(URL_BRIDGE_PROD, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${user.token}` 
        },
        body: JSON.stringify({ 
          pedido_id: idNormalizado, 
          estado_bridge: nuevoEstadoBridge 
        })
      });

      const contentType = res.headers.get("content-type");
      let data = null;
      if (contentType && contentType.includes("application/json")) {
        data = await res.json();
      }

      if (res.ok) {
        console.log(`✅ Bridge actualizado en PHP: ${idNormalizado} -> ${nuevoEstadoBridge}`);
        setEnvios(prev => prev.map(p => {
          const actualID = String(p.pedido_id || p.id);
          return actualID === idNormalizado ? { ...p, estado_bridge: nuevoEstadoBridge } : p;
        }));
      } else {
        console.error("❌ El servidor rechazó la acción del Bridge:", data?.error);
      }
    } catch (e) { 
      console.error("❌ Error de red en bridge con PHP:", e); 
    }
  }

  // ================================================================================
  // --- ACCIONES REPARTIDOR CONECTADAS A NUEVOS MÉTODOS PHP ---
  // ================================================================================
  async function handleIniciarRuta(envio) {
    const pedidoId = envio.pedido_id || envio.id;
    
    // Dispara tu nueva lógica en PHP (iniciar_ruta.php) que ya corre Pusher y actualiza la trazabilidad
    const ok = await enviarAccionDelivery('iniciar_ruta.php', pedidoId);
    
    if (ok) {
      // Sincronizamos el estado de la UI local del panel y cambiamos de pestaña automáticamente
      setEnvios(prev => prev.map(p => 
        String(p.pedido_id || p.id) === String(pedidoId) 
          ? { ...p, estado: 'en_ruta', estado_bridge: 'EN_RUTA' } 
          : p
      ));
      setFiltroActivo('en_ruta'); 
    }
  }

  async function handleConfirmarLlegada(envio) {
    const pedidoId = envio.pedido_id || envio.id;
    
    // Dispara tu lógica en PHP (confirmar_llegada.php) que avisa al cliente que el motorizado llegó
    const ok = await enviarAccionDelivery('confirmar_llegada.php', pedidoId);
    
    if (ok) {
      setEnvios(prev => prev.map(p => 
        String(p.pedido_id || p.id) === String(pedidoId) 
          ? { ...p, estado: 'en_ubicacion', estado_bridge: 'EN_UBICACION' } 
          : p
      ));
    }
  }

  async function handleConfirmarEntrega(envio) {
    const pedidoId = envio.pedido_id || envio.id;
    
    // Llama al endpoint de cierre final de entrega
    const ok = await enviarAccionDelivery('finalizar_entrega.php', pedidoId);
    
    if (ok) {
      // Movemos el pedido a la lista de confirmados/historial y lo sacamos de la lista activa
      setConfirmaciones(prev => [...prev, { ...envio, estado: 'COMPLETADO' }]);
      setEnvios(prev => prev.filter(p => String(p.pedido_id || p.id) !== String(pedidoId)));
      setFiltroActivo('entregados'); 
    }
  }

  // --- 1. EFECTO DE CARGA INICIAL (BASE DE DATOS) ---
 // --- 1. EFECTO DE CARGA INICIAL (BASE DE DATOS EN PRODUCCIÓN) ---
// --- 1. EFECTO DE CARGA INICIAL (BASE DE DATOS EN PRODUCCIÓN) ---
useEffect(() => {
  const cargarPedidosIniciales = async () => {
    if (!user?.token) return;
    try {
      // 🌐 CORRECCIÓN DE RUTA COINCIDENTE: Usamos el guion medio igual que en cPanel
      const res = await fetch('https://clavelinacarnes.com/clavelina-backend-php/src/Routes/delivery/pedidos-pendientes.php', {
        headers: { 'Authorization': `Bearer ${user.token}` }
      });
      
      if (res.ok) {
        const data = await res.json();
        const normalizados = data.map(p => ({
          ...p,
          pedido_id: p.pedido_id || p.id,
          envio: parseEnvio(p.envio || { 
            direccion: p.direccion, 
            nombre: p.nombre_cliente, 
            telefono: p.telefono 
          }),
          estado_bridge: p.estado_bridge || p.estadoBridge || 'ESPERANDO_LISTO'
        }));
        setEnvios(normalizados);
      }
    } catch (e) {
      console.error("Error cargando pedidos iniciales:", e);
    }
  };

  cargarPedidosIniciales();
}, [user?.token]);

  // --- 2. EFECTO DE PUSHER ---
  useEffect(() => {
    if (!deliveryUuid) return;

    const pusherInstance = new Pusher('ff59d4da6a1a8c01af49', { 
        cluster: 'us2', 
        forceTLS: true 
    });
    
    const globalChannel = pusherInstance.subscribe('delivery-global');
    const privateChannel = pusherInstance.subscribe(`delivery-${deliveryUuid}`);

    globalChannel.bind('nuevo-envio', (data) => {
      setEnvios(prev => {
        if (prev.some(p => String(p.pedido_id) === String(data.pedido_id))) return prev;
        return [{ ...data, estado_bridge: 'ESPERANDO_LISTO', envio: parseEnvio(data.envio) }, ...prev];
      });
    });

    privateChannel.bind('actualizar-bridge', (data) => {
      console.log("🚀 SIGNAL:", data);
      
      if (data.estado_bridge === 'ENTREGADO') {
        if (data.origen === 'cliente') {
          Swal.fire({
            title: '¡Confirmado por Cliente!',
            text: 'El cliente acaba de marcar el pedido como recibido.',
            icon: 'success',
            timer: 6000,
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            background: '#f0fff4'
          });
        }

        setEnvios(prev => {
          const pedido = prev.find(p => String(p.pedido_id) === String(data.pedido_id));
          if (pedido) setConfirmaciones(c => [...c, { ...pedido, estado: 'ENTREGADO' }]);
          return prev.filter(p => String(p.pedido_id) !== String(data.pedido_id));
        });
      } else {
        setEnvios(prev => {
          const index = prev.findIndex(p => String(p.pedido_id) === String(data.pedido_id));
          if (index === -1) return prev;
          const nuevos = [...prev];
          nuevos[index] = { ...nuevos[index], estado_bridge: data.estado_bridge };
          return nuevos;
        });
      }
    });

    return () => {
      pusherInstance.unsubscribe('delivery-global');
      pusherInstance.unsubscribe(`delivery-${deliveryUuid}`);
      pusherInstance.disconnect();
    };
  }, [deliveryUuid]);

  const handleAceptarRechazarClick = async (envio, action) => {
    if (!user?.token) return;
    const isAceptar = action === 'aceptar';
    const endpoint = isAceptar ? 'aceptar_pedido.php' : 'rechazar_pedido.php';
  
    try {
      // 🌐 RUTA HÍBRIDA/DIRECTA: Apuntamos directo a la carpeta física en cPanel igual que el login
      const urlDirecta = `https://clavelinacarnes.com/clavelina-backend-php/src/Routes/delivery/${endpoint}`;

      const res = await fetch(urlDirecta, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${user.token}` 
        },
        body: JSON.stringify({ pedido_id: envio.pedido_id })
      });
  
      const contentType = res.headers.get("content-type");
      let data = null;
  
      if (contentType && contentType.includes("application/json")) {
        data = await res.json();
      } else {
        const textError = await res.text();
        console.error("Respuesta no es JSON:", textError);
        throw new Error("El servidor devolvió un error inesperado.");
      }
  
      if (res.ok) {
        if (isAceptar) {
          setEnvios(prev => prev.map(e => 
            e.pedido_id === envio.pedido_id 
              ? { ...e, estado: 'en_proceso', delivery_id: user.id } 
              : e
          ));
          setFiltroActivo('en_proceso');
        } else {
          setEnvios(prev => prev.filter(e => e.pedido_id !== envio.pedido_id));
        }
      } else {
        alert(data?.error || "Error al procesar la solicitud");
      }
    } catch (error) {
      console.error("Error en la petición:", error);
      alert("Error de conexión: " + error.message);
    }
  };

  const pedidosAsignados = envios.filter(e => e.delivery_id === deliveryUuid || !e.delivery_id);
  const pendientes = pedidosAsignados.filter(e => ['PENDIENTE', 'ESPERANDO_PRECIO', 'ASIGNADO_A_DELIVERY'].includes((e.estado || '').toUpperCase()));
  const enProceso = pedidosAsignados.filter(e => ['ACEPTADO_POR_DELIVERY', 'EN_PROCESO', 'LISTO'].includes((e.estado || '').toUpperCase()));
  const enRuta = pedidosAsignados.filter(e => ['EN_RUTA', 'EN_UBICACION'].includes((e.estado || '').toUpperCase()));

  const renderGrupo = () => {
    let listado = [];
    if (filtroActivo === 'pendientes') listado = pendientes;
    else if (filtroActivo === 'en_proceso') listado = enProceso;
    else if (filtroActivo === 'en_ruta') listado = enRuta;
    else if (filtroActivo === 'entregados') return confirmaciones.map((c, i) => (
      <div key={i} className="alert alert-success mt-2">Pedido #{String(c.pedido_id).substring(0,8)} entregado</div>
    ));

    return listado.map((envioIndividual, idx) => (
      <div key={envioIndividual.pedido_id || idx} className="col-12 mb-3">
        <DeliveryCard
          envio={envioIndividual} 
          onAceptarRechazar={handleAceptarRechazarClick}
          onIniciarRuta={handleIniciarRuta} 
          onConfirmarLlegada={handleConfirmarLlegada}
          onConfirmarEntrega={handleConfirmarEntrega}
          onBridgeAction={handleBridgeAction}
        />
      </div>
    ));
  };

  return (
    <div className="container py-3">
      <div className="border-bottom pb-2 mb-4 text-center">
        <h2 className="fw-bold text-danger">Clavelina-Delivery</h2>
        <h5 className="text-muted">Hola, {nombreDelivery || 'repartidor'} 👋</h5>
      </div>

      <div className="d-flex justify-content-around gap-2 mb-4">
        {['pendientes', 'en_proceso', 'en_ruta', 'entregados'].map(f => (
          <div key={f} className={`card text-center p-2 flex-grow-1 ${filtroActivo === f ? 'border-danger border-2' : ''}`} 
               style={{ cursor: 'pointer' }} onClick={() => setFiltroActivo(f)}>
            <h6 className="small mb-1 text-capitalize">{f.replace('_', ' ')}</h6>
            <span className="fw-bold">
                {f === 'pendientes' ? pendientes.length : 
                 f === 'en_proceso' ? enProceso.length : 
                 f === 'en_ruta' ? enRuta.length : confirmaciones.length}
            </span>
          </div>
        ))}
      </div>

      <div className="row">{renderGrupo()}</div>
    </div>
  );
}